import { Component, Input } from "@angular/core";

declare const bootstrap: any;

const STATIC_MODAL_OPTIONS = {
  backdrop: "static",
  keyboard: false,
};
const CLOSE_FALLBACK_MS = 500;

@Component({
  selector: "app-loading-dialog",
  templateUrl: "./loading-dialog.component.html",
  styleUrl: "./loading-dialog.component.scss",
})
export class LoadingDialogComponent {
  @Input() modalId = "loadingDialog";
  @Input() title = "กำลังดำเนินการ";
  @Input() message = "กรุณารอสักครู่";
  @Input() stackAboveModal = false;

  open(): void {
    const modalEl = document.getElementById(this.modalId);

    if (modalEl == null) {
      return;
    }

    bootstrap.Modal.getOrCreateInstance(modalEl, STATIC_MODAL_OPTIONS).show();
  }

  close(afterHidden?: () => void): void {
    const modalEl = document.getElementById(this.modalId);

    if (modalEl == null) {
      afterHidden?.();
      return;
    }

    this.blurFocusedElementInside(modalEl);
    const modal = bootstrap.Modal.getOrCreateInstance(modalEl, STATIC_MODAL_OPTIONS);
    let completed = false;
    const complete = () => {
      if (completed) {
        return;
      }

      completed = true;
      afterHidden?.();
    };
    const completeWithFallbackCleanup = () => {
      if (!completed && modalEl.classList.contains("show")) {
        this.forceHideModalElement(modalEl);
      }

      complete();
    };

    modalEl.addEventListener("hidden.bs.modal", complete, { once: true });

    if (modalEl.classList.contains("show")) {
      modal.hide();
      setTimeout(completeWithFallbackCleanup, CLOSE_FALLBACK_MS);
      return;
    }

    modalEl.addEventListener("shown.bs.modal", () => {
      modal.hide();
    }, { once: true });
    setTimeout(completeWithFallbackCleanup, CLOSE_FALLBACK_MS);
  }

  private blurFocusedElementInside(modalEl: HTMLElement): void {
    const activeElement = document.activeElement;

    if (activeElement instanceof HTMLElement && modalEl.contains(activeElement)) {
      activeElement.blur();
    }
  }

  private forceHideModalElement(modalEl: HTMLElement): void {
    modalEl.classList.remove("show");
    modalEl.setAttribute("aria-hidden", "true");
    modalEl.removeAttribute("aria-modal");
    modalEl.removeAttribute("role");
    modalEl.style.display = "none";

    if (document.querySelector(".modal.show") == null) {
      document.body.classList.remove("modal-open");
      document.body.style.removeProperty("overflow");
      document.body.style.removeProperty("padding-right");
      document.querySelectorAll(".modal-backdrop").forEach((backdrop) => backdrop.remove());
    }
  }
}
